import React, {useEffect, useRef} from 'react';
import {useRecoilState} from 'recoil';

import {isOpenMyPageModal} from '../../../store';
import MyPageButton from './Button';

export default function MyPageModal() {
  const [openModal, setOpenModal] = useRecoilState(isOpenMyPageModal);

  const wrapperRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });

  const handleClickOutside = (event: any) => {
    if (wrapperRef && !wrapperRef?.current?.contains(event.target)) {
      setOpenModal(false);
    }
  };
  return (
    <div
      className="modal-wrapper"
      style={{display: openModal ? 'flex' : 'none'}}>
      <div className="modal-contents comment-m" ref={wrapperRef}>
        <MyPageButton click={() => setOpenModal(false)} />
      </div>
    </div>
  );
}
